import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import getPerksAllowanceTotal from 'core/application/adminDashboard/reimbursements/perks/getPerksAllowanceTotal'

import { Col, Row, Skeleton } from 'common/components'
import { useQueryRequestV2 } from 'common/hooks'

import AllowanceDataBox from '../../../common/allowanceDataBox'

type PerksExpenseApprovalsProps = {
  planPeriodId: string
  reload: boolean
  onReloaded?: () => void
}

const PerksAllowanceBenefitSummary: React.FC<PerksExpenseApprovalsProps> = (props) => {
  const { t: translate } = useTranslation()
  const {
    data: totalAmounts,
    isLoading: isLoading,
    reload: reload,
  } = useQueryRequestV2({ initialState: null, queryFn: () => getPerksAllowanceTotal(props.planPeriodId) })

  useEffect(() => {
    reload().then(() => {
      if (props.onReloaded) {
        props.onReloaded()
      }
    })
  }, [props.reload])

  useEffect(() => {
    reload()
  }, [props.planPeriodId])

  return (
    <Skeleton active={true} loading={isLoading} className="mb-32">
      <Row className="mb-8" gutter={24}>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} className="mb-8">
          {totalAmounts && (
            <AllowanceDataBox
              title={translate('admin-dashboard.reimbursements.perks-reimbursements-due.total-allowances')}
              amount={totalAmounts?.allowancesOfferedToDate}
            />
          )}
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <AllowanceDataBox
            title={translate('admin-dashboard.reimbursements.perks-reimbursements-due.total-reimbursement-to-date')}
            amount={totalAmounts?.reimbursementsToDate}
          />
        </Col>
      </Row>
      <Row className="mb-8" gutter={24}>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <AllowanceDataBox
            title={translate('admin-dashboard.reimbursements.perks-reimbursements-due.total-allowances-remaining')}
            amount={totalAmounts?.remainingUnusedAllowance}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <AllowanceDataBox
            title={translate('admin-dashboard.reimbursements.perks-reimbursements-due.total-reimbursement')}
            amount={totalAmounts?.reimbursementsDue}
          />
        </Col>
      </Row>
    </Skeleton>
  )
}

export default PerksAllowanceBenefitSummary
